export enum TaskTypesEnum {
  checklist = 1,
  communication = 2,
}
